<template>
  <table>
    <thead class="sticky top-0 z-20 bg-white">
      <tr class="flex">
        <th class="sticky left-0 z-30 flex items-center justify-center flex-grow flex-shrink-0 w-12 p-2 overflow-hidden text-sm font-bold text-center border-b border-r border-solid sm:w-40 border-neutral-200 h-11 bg-neutral-100 text-neutral-600">Bruger</th>
        <th class="flex items-center justify-center flex-shrink-0 w-56 p-2 overflow-hidden text-sm font-bold text-center border-b border-r border-solid border-neutral-200 h-11 bg-neutral-100 text-neutral-600">Type</th>
        <th class="flex items-center justify-center flex-shrink-0 w-56 p-2 overflow-hidden text-sm font-bold text-center border-b border-r border-solid border-neutral-200 h-11 bg-neutral-100 text-neutral-600">Dato(er)</th>
        <th class="flex items-center justify-center flex-shrink-0 w-56 p-2 overflow-hidden text-sm font-bold text-center border-b border-solid border-neutral-200 h-11 bg-neutral-100 text-neutral-600">Oprettet</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="event in groupedEvents" :key="event.batch_id" class="flex group hover:bg-neutral-50">
        <td class="sticky left-0 z-10 flex-shrink-0 w-12 text-sm bg-white border-b border-r border-solid cursor-pointer sm:w-40 group-hover:bg-neutral-50 sticky-column border-neutral-200"
            @mouseover="showUserInfo(event.user, $event)"
            @mouseleave="$emit('hide-user-info')">
          <div class="px-2 w-full h-full overflow-hidden text-ellipsis whitespace-nowrap leading-[2.75rem]" :title="event.user.first_name + ' ' + event.user.last_name">
            <span class="sm:hidden">{{ usersStore.getUserInitials(event.user) }}</span>
            <span class="hidden sm:inline">{{ event.user.first_name + " " + event.user.last_name }}</span>
          </div>
        </td>
        <td class="flex items-center justify-center flex-shrink-0 w-56 p-2 text-sm border-b border-r border-solid border-neutral-200">
          {{ event.type }}
        </td>
        <td class="flex items-center justify-center flex-shrink-0 w-56 p-2 text-sm border-b border-r border-solid border-neutral-200">
          {{ formatDateRange(event.start_date, event.end_date) }}
        </td>
        <td class="flex items-center justify-center flex-shrink-0 w-56 p-2 text-sm border-b border-solid border-neutral-200">
          {{ formatDate(event.created_date) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
  
  <script setup>
  import { computed, defineProps, defineEmits, inject } from 'vue';
  import { format, parseISO } from 'date-fns';
  import { da } from 'date-fns/locale';

  const usersStore = inject("usersStore");
  
  const props = defineProps({
    users: {
      type: Array,
      required: true,
    },
  });
  
  const emit = defineEmits(['show-user-info', 'hide-user-info']);
  
  const groupedEvents = computed(() => {
    const events = props.users.flatMap(user => 
      user.events.map(event => ({ ...event, user }))
    );
  
    const grouped = events.reduce((acc, event) => {
      if (!acc[event.batch_id]) {
        acc[event.batch_id] = {
          ...event,
          start_date: event.date,
          end_date: event.date,
        };
      } else {
        if (new Date(event.date) < new Date(acc[event.batch_id].start_date)) {
          acc[event.batch_id].start_date = event.date;
        }
        if (new Date(event.date) > new Date(acc[event.batch_id].end_date)) {
          acc[event.batch_id].end_date = event.date;
        }
      }
      return acc;
    }, {});
  
    return Object.values(grouped).sort((a, b) => 
      new Date(b.created_date) - new Date(a.created_date)
    );
  });
  
  function formatDate(dateString) {
    return format(parseISO(dateString), 'dd/MM/yyyy HH:mm:ss', { locale: da });
  }
  
  function formatDateRange(startDate, endDate) {
  if (startDate === endDate) {
    return format(parseISO(startDate), 'dd/MM/yyyy', { locale: da });
  }
  return `${format(parseISO(startDate), 'dd/MM/yyyy', { locale: da })} - ${format(parseISO(endDate), 'dd/MM/yyyy', { locale: da })}`;
}

  function showUserInfo(user, event) {
    emit('show-user-info', user, event.clientX, event.clientY);
  }
  </script>